module.exports = __webpack_public_path__ + "assets/Spacing.4f061454b0af8aefa787840d9eba7d2b.png";